import { initComponent } from './core/init-component';
import { bindAll } from './utils/bind-all';

initComponent('.js-toast', (toast) => {
  document.body.appendChild(toast);

  const closeToast = () => {
    toast.classList.remove('active');
  };

  bindAll(
    toast,
    '.js-toast-close',
    'click',
    closeToast
  );

  return {
    unload() {}
  };
});